import { Box, Button, Container, useMediaQuery, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { useLocation, useNavigate } from 'react-router-dom'
import CustomButton from '../../Components/CustomButton/CustomButton'
import { Input } from '../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../utils/api'
import urls from '../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import UploadOperations from './UploadOperations'
import EditOperationForm from './EditOperationForm'
import { width } from '@fortawesome/free-solid-svg-icons/faInfo'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
export const GestionOperations = () => {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const navigate = useNavigate()
  const location = useLocation()

  const [operations, setOperations] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [loading, setLoading] = useState(false)
  const [infoshow, setInfoShow] = useState(true)
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])

  const { handleSubmit, control } = useForm({
    defaultValues: {
      Date: '',
      NumeroCompte: '',
      Nom: '',
      Montant: '',
      SousCategorie: '',
      Categorie: '',
    },
  })

  useEffect(() => {
    fetchOperations()
  }, [location.search])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudDashboardDetailsOperations}?${location.search.slice(1)}`
    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }
  const fetchOperations2 = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudDashboardDetailsOperations}?${location.search.slice(1)}`
    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({
        ...response.data,
        results: [...operations.results, ...response.data.results],
      })
      setLoading(false)
    }
    setLoading(false)
  }

  const filterOperations = (data) => {
    const queryParams = new URLSearchParams(data).toString()
    navigate(`?${queryParams}`)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('finance.gestionOperations.selectOneOperation'))
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }
  return (
    <>
      <Box bgcolor={'#001b42'} p={2}>
        <Container maxWidth="xl" sx={{ display: infoshow ? 'block' : 'none' }}>
          <form onSubmit={handleSubmit(filterOperations)}>
            <Box
              display={'flex'}
              alignItems={isMobile ? 'unset' : 'center'}
              flexDirection={isMobile ? 'column' : 'row'}
              flexWrap="wrap"
            >
              <Input
                control={control}
                name="Date"
                inputProps={{ variant: 'filled', type: 'date', size: 'small' }}
                rules={{ required: false }}
              />

              <Input
                size="small"
                control={control}
                name="NumeroCompte"
                inputProps={{
                  variant: 'filled',
                  type: 'number',
                  size: 'small',
                }}
                rules={{ required: false }}
                label={t('finance.gestionOperations.accountNumber')}
              />
              <Input
                size="small"
                control={control}
                inputProps={{ variant: 'filled', size: 'small' }}
                rules={{ required: false }}
                name="Nom"
                label={t('finance.gestionOperations.accountName')}
              />
              <Input
                size="small"
                control={control}
                inputProps={{
                  variant: 'filled',
                  size: 'small',
                }}
                rules={{ required: false }}
                name="SousCategorie"
                label={t('finance.gestionOperations.subCategory')}
              />
              <Input
                size="small"
                control={control}
                inputProps={{
                  variant: 'filled',
                  size: 'small',
                }}
                rules={{ required: false }}
                name="Categorie"
                label={t('finance.gestionOperations.categoryLabel')}
              />
              <Input
                size="small"
                control={control}
                inputProps={{
                  variant: 'filled',
                  size: 'small',
                  style: { maxWidth: isMobile ? '100%' : '200px' },
                }}
                rules={{ required: false }}
                name="Montant"
                label={t('finance.gestionOperations.amount')}
              />

              <Button variant="contained" type="submit" sx={{ height: 52 }}>
                {t('finance.gestionOperations.filter')}
              </Button>
            </Box>
          </form>
        </Container>
        <Box display={'flex'} justifyContent={'center'} mt={1}>
          {isMobile && (
            <>
              {infoshow ? (
                <KeyboardArrowUpIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              ) : (
                <KeyboardArrowDownIcon
                  sx={{
                    color: 'white',
                    bgcolor: 'gray',
                    borderRadius: 5,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setInfoShow(!infoshow)
                  }}
                />
              )}
            </>
          )}
        </Box>
      </Box>
      <Box px={isMobile ? 1 : 6} sx={{ overflowY: 'hidden', mt: '16px' }}>
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box color={'white'} display={'flex'} gap={2}>
            <UploadOperations />
            <CreateOperationForm setOperations={setOperations} />
            <EditOperationForm
              selectedRow={selectedRows}
              operations={operations}
              UpdateOperations={fetchOperations}
            />
            {isMobile ? (
              <Box onClick={deleteBulkOperations}>{t('finance.common.delete')}</Box>
            ) : (
              <CustomButton onClick={deleteBulkOperations}>{t('finance.common.delete')}</CustomButton>
            )}
          </Box>
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
          fetchOperations2={fetchOperations2}
        />
      </Box>
    </>
  )
}
